import { Heading } from '@spark-web/heading';
import { ContentDialog } from '@spark-web/modal-dialog';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

import { Button as BrighteButton } from '~/components/common/button';
import { Footer } from '~/components/footer';
import { AnalyticsEvents } from '~/constants/analytics';
import { useModal } from '~/hooks/useModal';
import { useAnalyticsContext } from '~/provider/AnalyticsProvider';
import { MarketplaceVendor } from '~/types/marketplace';

type SelectedVendorProps = {
  vendor: MarketplaceVendor;
  numOfVendors: number;
  onRequestQuotes: () => void;
};

export const SelectedVendor = ({ vendor, numOfVendors, onRequestQuotes }: SelectedVendorProps) => {
  const { close, onCloseAutoFocus, isOpen } = useModal('selected-vendor');
  const { track } = useAnalyticsContext();

  const onAddAnotherVendor = () => {
    close();
    track(AnalyticsEvents.SelectedAddAnotherClicked);
  };

  const onRequestQuotesPressed = () => {
    onRequestQuotes();
    track(AnalyticsEvents.SelectedRequestQuotesClicked);
  };

  return (
    <ContentDialog
      title="Brighte Marketplace"
      showCloseButton
      isOpen={isOpen}
      onToggle={close}
      onCloseAutoFocus={onCloseAutoFocus}
    >
      <Stack gap="xxlarge">
        <Heading level="2">{`You've added ${vendor?.tradingName}`}</Heading>
        <Stack gap="xlarge">
          {numOfVendors > 0 ? (
            <>
              <Text>We recommend adding {numOfVendors} more vendors before requesting quotes.</Text>
              <BrighteButton rounded onClick={onAddAnotherVendor}>
                Add another vendor
              </BrighteButton>
            </>
          ) : (
            <Text>{"You're all set to request quotes from your selected vendors."}</Text>
          )}
          <BrighteButton rounded onClick={onRequestQuotesPressed}>
            Request quotes
          </BrighteButton>
          <Footer />
        </Stack>
      </Stack>
    </ContentDialog>
  );
};
